import React from "react";
import { SidebarMenuItem } from "./SidebarMenuItem";
import { PageEnum } from "src/helpers/Enums";

const SidebarMenuMain = () => {
  return (
    <div className={"w-full flex flex-col gap-[10px]"}>
      <SidebarMenuItem to="/dashboard" title={PageEnum.DASHBOARD} />
      <SidebarMenuItem to="/products" title={PageEnum.PRODUCTS} />
      <SidebarMenuItem to="/listicles" title={PageEnum.LISTICLES} />
      <SidebarMenuItem to="/templates" title={PageEnum.TEMPLATES} />
      <SidebarMenuItem to="/pages" title={PageEnum.PAGES} />
      <SidebarMenuItem to="/campaigns" title={PageEnum.CAMPAIGNS} />
      <SidebarMenuItem to="/reports" title={PageEnum.REPORTS} />
      <SidebarMenuItem to="/trends" title={PageEnum.TRENDS} />
    </div>
  );
};

export { SidebarMenuMain };
